import { fetchApi } from 'shared/functions';

export const fetchESGCoverage = () => {
  return fetchApi(`/esg/api/esg-coverage/`)
    .then(res => res.json())
    .then(({ data }) => data);
};
